import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { LegalChanges } from '@/features/legal/LegalChanges';
import { AuthProvider } from '@/shared/auth/AuthProvider';
import type { SessionStore } from '@/shared/auth/session';

/** Wspólni dostawcy kontekstu: dane (TanStack Query) i sesja użytkownika. */
export function Providers({
  children,
  queryClient,
  store,
}: {
  children: ReactNode;
  queryClient: QueryClient;
  store?: SessionStore;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      {store ? (
        <AuthProvider store={store}>
          {children}
          <LegalChanges />
        </AuthProvider>
      ) : (
        <AuthProvider>
          {children}
          <LegalChanges />
        </AuthProvider>
      )}
    </QueryClientProvider>
  );
}
